export const SORT_TYPE = {
    FIRST_NEW: 'firstNew',
    FIRST_OLD: 'firstOld',
    ALPHABET_ASC: 'alphabetAsc',
    ALPHABET_DESC: 'alphabetDesc',
} as const;
